import { ChangeDetectionStrategy, Component, EventEmitter, input, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'tt-menu',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
  template: `
    <ng-template>
      <div aria-label="{{ ariaLabel() }}" class="tt-menu" role="menu" [attr.data-testid]="dataTestId()" (click)="closed.emit($event)">
        <ng-content />
      </div>
    </ng-template>
  `,
  styleUrls: ['./menu.scss'],
})
export class MenuComponent {
  public ariaLabel = input<string>();
  public dataTestId = input<string>();

  @ViewChild(TemplateRef) public template!: TemplateRef<unknown>;

  @Output() public closed = new EventEmitter<void>();
}
